import React, { Component } from "react";
import Pagination from "react-js-pagination";
 
export default class Paginate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: 1
    };
  }
 
  render() {
    // let {activePage} = this.state;
    let {activePage,itemsCountPerPage,totalItemsCount,pageRangeDisplayed,handlePageChange} = this.props;
    return (
      <div>
        <Pagination
          activePage={activePage}
          itemsCountPerPage={itemsCountPerPage}
          totalItemsCount={totalItemsCount}
          pageRangeDisplayed={pageRangeDisplayed}
          onChange={handlePageChange}
        />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/Modules/Helper/Paginate.js